<!-- 宣传资料下载 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div style="padding: 0 20px">
        <el-tabs v-model="queryInfo.type_id" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in type_list"
            :key="index"
            :label="item.type_name"
            :name="item.type_id.toString()"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="folderListBox">
        <div
          class="folderItem"
          v-for="(item, index) in tableList"
          :key="index"
          @click="details(item)"
        >
          <img class="img" src="../../assets/folder.png" alt="" />
          <p class="cont">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
// 宣传资料下载
export default {
  name: "tobFolderList",
  components: { MyButton },
  data() {
    return {
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
      },
      tableList: [],
      timeFrame: [],
      selfnumzbsm: "",
      typeOptions: [{ value: 1, label: "宣传资料" }],
      jsjyguljsy_text: "",
      type_list: [],
    };
  },
  computed: {
    typeMap() {
      return new Map(this.typeOptions.map((item) => [item.value, item.label]));
    },
  },
  created() {
    this.queryTable();
  },
  methods: {
    handleClick(e) {
      console.log("handleClick", e.name);
      this.queryInfo.type_id = e.name;
      this.queryTable();
    },
    details(row) {
      console.log("details", row);
      this.$router.push({
        path: "/tobFileList",
        query: {
          folder_id: row.id,
        },
      });
    },
    // 列表数据
    async queryTable(_type) {
      let params = deepClone(this.queryInfo);
      const res = await commonApi.getTobFolderList(params);
      if (res.code == 200) {
        this.queryInfo.total = res.data.list.total;
        this.tableList = res.data.list.data;

        this.type_list = res.data.type_list;

        this.type_list.forEach((item) => {
          if (item.is_select == 1) {
            this.queryInfo.type_id = item.type_id.toString();
          }
        });
      } else {
        this.$message.error(res.message);
      }
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
      };
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  //   .table {
  //     min-height: calc(100vh - 330px);
  //     border: 1px solid #ddd;
  //     border-radius: 10px;
  //     .studentLabel {
  //       display: inline-block;
  //       padding: 5px 10px;
  //       background-color: #409eff;
  //       color: #fff;
  //       border-radius: 4px;
  //       margin: 0 5px 5px 0;
  //     }
  //   }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin: 10px;
  display: flex;
  justify-content: space-around;
  height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}
.activeNumber {
  color: #f40;
}
.item_a1 {
  background-color: #f5f3ff;
}
.item_a2 {
  background-color: #edfffa;
}
.item_a3 {
  background-color: #fff6ed;
}
.item_a4 {
  background-color: #ffefef;
}
/deep/.el-dialog__footer {
  text-align: center;
}

.initialLogin {
  background: #ffebeb;
  border-radius: 8px 8px 8px 8px;
  line-height: 45px;
  padding: 0 20px 0 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  .initialLeft {
    color: #191b27;
    font-size: 15px;
    font-weight: 500;
  }
  .initialRight {
    height: 32px;
    width: 72px;
    background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-top: -3px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
.initialNum {
  font-weight: bold;
  color: red;
  font-size: 20px;
  margin-bottom: 10px;
}
.folderListBox {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  .folderItem {
    width: 100px;
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    .img {
      width: 100px;
      height: 100px;
    }
    .cont {
      word-wrap: break-word;
    }
  }
}

/deep/.el-tabs__nav {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0;
}
</style>
